import { ca } from '@cian/analytics';

type TParams = {
  chatId: string;
  messageId: string;
  isReply: boolean;
};

export function trackMessageSent({ chatId, messageId, isReply }: TParams) {
  ca('eventSite', {
    action: 'Click_sent',
    category: 'Chat',
    name: 'oldevent',
    page: {
      extra: {
        chat_id: chatId,
        message_id: messageId,
        is_reply: isReply,
      },
    },
  });
}
